module.exports = __webpack_public_path__ + "static/media/app-of.ae123e6b.png";